import React, { useState } from "react";
import {
  Image,
  InputGroup,
  Button,
  Form,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import FilterComponent from "./FilterButtons";
import { Droppable } from "react-beautiful-dnd";
import { useRouterParams } from "../../../abstracts";
import ActualSourceFieldComponent from "./ActualSourceFieldComponent";
import { isEmpty } from "lodash-es";
import { AddToolTip, FormControlSearch } from "../../../components";

const SourceContainer = (props) => {
  const { characters, setCharacters, column, setDrag, mapped, data } = props;
  const [searchBar, showSearchBar] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  // const [isOpen, setisOpen] = useState({ isOpen: false, id: null });
  const numberOfFields = () =>
    characters.filter((e) => {
      if (Filter == "All") {
        return e;
      } else if (Filter == "Mapped") {
        return e.mapped;
      } else {
        return !e.mapped;
      }
    }).length;
  const { mapType } = useRouterParams();
  const [Filter, setFilter] = useState("All");
  const [list, setList] = useState(characters);
  const [showClear, setShowClear] = useState(false);

  const handleChange = (e) => {
    //    e.preventDefault();
    setShowClear(true);
    // handleChange(e);
    setSearchTerm(e.target.value);
    setList(
      characters.filter((c) =>
        c.fieldName.toLowerCase().includes(e.target.value.toLowerCase())
      )
    );
  };

  return (
    <div
      className={
        mapType == 3 ? "SourceContainerPassthrough" : "SourceContainer"
      }
    >
      <div
        className="SourceSearchButtonContainer"
        style={{
          width: "100%",
        }}
      >
        <div className="SourceTextContainer">
          <p className="SourceText">Source</p>
        </div>
        {mapType == 3 ? (
          <></>
        ) : (
          <div className="searchIconContainer-var">
            <Button
              variant="link"
              className="search-with-api-button"
              onClick={() => showSearchBar(!searchBar)}
            >
              <Image
                className="searchIcon"
                src="/assets/icons/svg/search.svg"
              />
            </Button>
          </div>
        )}
      </div>

      <div className="FileNameContainer">
        <div className="FileNameText w-100" id="MappingFileName">
          {data.fileName?.length > 35 ? (
            <AddToolTip name={data.fileName} placement="top">
              {(data.fileName || "").slice(0, 35)}...
            </AddToolTip>
          ) : (
            <div> {data.fileName}</div>
          )}
        </div>
        <div className="NumberOfFieldsText w-100" id="NumberOfFields">
          {numberOfFields()} Fields available in source file
        </div>
      </div>

      {(mapType == 3 || searchBar) && (
        <div className="SearchBarContainer-var">
          {/* <Form>
            <InputGroup> */}
          <div className="mapper-source-search-text-var cross-override-close">
            <InputGroup>
              <InputGroup.Prepend>
                <div className="passthrough-search-icon-postion ml-2">
                  <i class="fal fa-search" aria-hidden="true"></i>
                </div>
              </InputGroup.Prepend>
              <FormControlSearch
                size="sm"
                screen={
                  mapType == 3 ? "mapper-passthrough" : "mapper-source-search"
                }
                id="source-search-box"
                type="text"
                className={
                  mapType == 3
                    ? "source-search-box-var cross-override-close pl-5 w-70 mr-0"
                    : "source-search-box pl-5 w-70 pr-4"
                }
                placeholder={
                  mapType == 3 ? "Search" : "Search source fields here"
                }
                onChange={handleChange}
                autoComplete="off"
                onKeyPress={(e) => {
                  e.key === "Enter" && handleChange(e);
                }}
              />
            </InputGroup>
          </div>
          {/* </InputGroup>
          </Form> */}
        </div>
      )}

      {mapType == 3 ? (
        <></>
      ) : (
        <FilterComponent
          Filter={Filter}
          setFilter={setFilter}
          setList={setList}
          characters={characters}
        />
      )}
      <Droppable droppableId={column}>
        {(provided) => (
          <ul
            className={
              mapType == 3
                ? "fieldContainer-source-passthrough"
                : "fieldContainer-source"
            }
            {...provided.droppableProps}
            ref={provided.innerRef}
          >
            {characters
              .filter((e) => {
                if (
                  e.fieldName.toLowerCase().includes(searchTerm.toLowerCase())
                ) {
                  if (Filter == "All") {
                    return e;
                  } else if (Filter == "Mapped") {
                    return e.mapped;
                  } else {
                    return !e.mapped;
                  }
                }
              })
              .map((item, index) => {
                return (
                  <ActualSourceFieldComponent
                    item={item}
                    index={index}
                    mapped={mapped}
                    characters={characters}
                    setCharacters={setCharacters}
                  />
                );
              })}
            {isEmpty(characters) ? (
              <div className="ft-12">No fields found</div>
            ) : null}
            {provided.placeholder}
          </ul>
        )}
      </Droppable>
    </div>
  );
};

export default SourceContainer;
